export const messages = {
  en: {
    shopReturnAddress: {
      title: 'Return Address',
      addTitle: 'Add Return Address',
      editTitle: 'Edit Return Address',
      deleteTitle: 'Confirm Operation',
      deleteContent: 'Confirm to delete return address',
      addressId: 'Address ID',
      receiverName: 'Receiver Name',
      contactNumber: 'Contact Number',
      detailedAddress: 'Detailed Address',
      sequence: 'Sequence',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      wrongClick: 'Wrong Click',
      addSuccess: 'Add Success',
      editSuccess: 'Edit Success',
      deleteSuccess: 'Delete Success',
      requiredName: 'Receiver name is required',
      requiredPhone: 'Contact number is required',
      requiredSeq: 'Sequence is required',
      invalidPhone: 'Invalid phone number format',
      nameTooLong: 'Receiver name too long',
      addressTooLong: 'Detailed address too long',
      invalidSeq: 'Sequence must be number'
    }
  },
  zh: {
    shopReturnAddress: {
      title: '退货地址',
      addTitle: '添加退货地址',
      editTitle: '修改退货地址',
      deleteTitle: '请确认您的操作',
      deleteContent: '确定删除退货地址',
      addressId: '地址ID',
      receiverName: '收货人名称',
      contactNumber: '联系电话',
      detailedAddress: '详细地址',
      sequence: '排序',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      add: '新增',
      cancel: '取消',
      confirm: '确认',
      save: '保存',
      wrongClick: '点错了',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      requiredName: '收货人名称不能为空',
      requiredPhone: '联系电话不能为空',
      requiredSeq: '排序不能为空',
      invalidPhone: '联系电话格式错误',
      nameTooLong: '收货人名称太长',
      addressTooLong: '详细地址太长',
      invalidSeq: '排序不是有效数字'
    }
  }
}